/**
 * Client-side analytics wrapper using posthog-js
 *
 * Initializes PostHog on first use if VITE_POSTHOG_KEY is set.
 * No-ops silently when not configured (dev environment).
 */

import type { EventName, EventProperties } from "@repo/analytics";
import posthog from "posthog-js";

let initialized = false;

function ensureInitialized(): boolean {
	if (initialized) return true;

	const apiKey = import.meta.env.VITE_POSTHOG_KEY;
	if (!apiKey) return false;

	posthog.init(apiKey, {
		api_host: import.meta.env.VITE_POSTHOG_HOST ?? "https://us.i.posthog.com",
		loaded: () => {
			initialized = true;
		},
	});
	initialized = true;
	return true;
}

/**
 * Track a client-side analytics event with type-safe properties.
 * No-ops when PostHog is not configured.
 */
export function trackClientEvent<T extends EventName>(
	event: T,
	properties: EventProperties<T>
): void {
	if (!ensureInitialized()) return;
	posthog.capture(event, properties);
}
